import { render, staticRenderFns } from "./help-link.vue?vue&type=template&id=67012e0a&scoped=true&"
import script from "./help-link.vue?vue&type=script&lang=js&"
export * from "./help-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67012e0a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67012e0a')) {
      api.createRecord('67012e0a', component.options)
    } else {
      api.reload('67012e0a', component.options)
    }
    module.hot.accept("./help-link.vue?vue&type=template&id=67012e0a&scoped=true&", function () {
      api.rerender('67012e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application-level/help-system/help-link.vue"
export default component.exports